import { FC } from 'react';
import { css } from '@emotion/react';
import { noop } from 'lodash-es';
import { theme } from '@frontend/theme';
import { OptionSwitchField as DSOptionSwitchField, FieldChangeEvent, Text } from '@frontend/design-system';

const fieldLabelTextStyle = css`
  display: block;
  margin-bottom: ${theme.spacing(0.5)};
`;

interface OptionSwitchOption {
  label: string;
  value: string;
}

export interface OptionSwitchFieldProps {
  id: string;
  name: string;
  label: string;
  'aria-invalid': boolean;
  touched: boolean;
  error?: string;
  onBlur: () => void;
  onChange: (e?: FieldChangeEvent) => void;
  value: string;
  options: Array<OptionSwitchOption>;
}

export const OptionSwitchField: FC<OptionSwitchFieldProps> = ({
  id,
  name,
  label,
  'aria-invalid': ariaInvalid,
  touched,
  error,
  onBlur,
  onChange,
  value,
  options,
}) => {
  const hasError = ariaInvalid && touched && !!error;
  const errorMessage = hasError ? error : '';

  return (
    <>
      {label && (
        <Text id={`${id}-label`} weight='regular' css={fieldLabelTextStyle}>
          {label}
        </Text>
      )}
      <DSOptionSwitchField
        id={id}
        name={name}
        label=''
        value={value}
        error={errorMessage}
        touched={touched}
        active={false}
        aria-invalid={ariaInvalid}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={noop}
      >
        {options.map((option) => (
          <DSOptionSwitchField.Option key={option.value} value={option.value}>
            {option.label}
          </DSOptionSwitchField.Option>
        ))}
      </DSOptionSwitchField>
    </>
  );
};
